import { ActionIcon, type ActionIconProps, type PolymorphicComponentProps, Tooltip } from "@mantine/core";

import classes from "./styles.module.css";

export interface IconButtonProps extends PolymorphicComponentProps<"button", ActionIconProps> {
    tooltip: string;
}
export function GuideNavButton({ children, tooltip, ...rest }: IconButtonProps) {
    return (
        <Tooltip position="bottom-start" label={tooltip} zIndex="var(--mantine-priority-high)">
            <ActionIcon
                aria-label={tooltip}
                className={classes.disabledNavButton}
                variant="transparent"
                size="md"
                {...rest}
            >
                {children}
            </ActionIcon>
        </Tooltip>
    );
}
